import { PermissionGroup } from "../Model/PermissionGroup";

export class GetPermissionGroupsList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetPermissionGroupsList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return PermissionGroup.createFromResponseData(record);
        }),
      );
    }
  };